"use client";

import { initializeFacebook } from "@faire/deprecated-retailer-visitor-shared/initializers/facebook";
import { initializeGTM } from "@faire/deprecated-retailer-visitor-shared/initializers/googleTagManager";
import { initializeHotjar } from "@faire/deprecated-retailer-visitor-shared/initializers/hotjar";
import { loadAppleLoginScript } from "@faire/deprecated-retailer-visitor-shared/initializers/initializeAppleLogin";
import { initializeLocalSessionData } from "@faire/deprecated-retailer-visitor-shared/initializers/initializeLocalSessionData";
import {
  initializeFaireGeneralWebSocketChannels,
  initializeNotificationWebSocketChannels,
} from "@faire/deprecated-retailer-visitor-shared/initializers/initializeWebSocketChannels";
import { loadGoogleLoginScript } from "@faire/deprecated-retailer-visitor-shared/initializers/loadGoogleLoginScript";
import {
  initializeLoggedOutQualtrics,
  initializeRetailerPortalQualtrics,
} from "@faire/deprecated-retailer-visitor-shared/initializers/qualtrics";
import { initializeUXCam } from "@faire/deprecated-retailer-visitor-shared/initializers/uxcam";
import { subscribeAddToCartEvents } from "@faire/deprecated-retailer-visitor-shared/stores/domain/CartStore/events";
import { useInvalidateProductReviewCampaignComponents } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useInvalidateProductReviewCampaignComponents";
import { useNotificationCount } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useNotificationCount";
import { useUserStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useUserStore";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";
import { History } from "history";
import React, { useEffect } from "react";

import { useFaireDirectPopFoiModalOnPageNavEffect } from "./__internal__/useFaireDirectPopFoiModalOnPageNavEffect";

const usePostAppInitialization = (history: History) => {
  const { handleRetailerUserNotificationChannelMessage } =
    useNotificationCount();
  const { handleInvalidateProductReviewCampaignComponents } =
    useInvalidateProductReviewCampaignComponents();
  const { user, isAdminUser } = useUserStore();

  useFaireDirectPopFoiModalOnPageNavEffect(history);

  /**
   * Executes the necessary steps of src/postAppInteractiveInitialize.ts
   * on the client of the nextjs app.
   */

  useEffect(() => {
    initializeFacebook();
    initializeGTM();
    initializeLoggedOutQualtrics();
    loadAppleLoginScript();
    loadGoogleLoginScript();
  }, []);

  const _initializeQualtrics = useEffectEvent(() => {
    initializeRetailerPortalQualtrics(user);
  });
  useEffect(() => {
    _initializeQualtrics();
  }, [_initializeQualtrics]);

  const _initializeUXCam = useEffectEvent(() => {
    initializeUXCam(user, isAdminUser);
  });
  useEffect(() => {
    _initializeUXCam();
  }, [_initializeUXCam]);

  useEffect(() => {
    initializeLocalSessionData(user?.token);
  }, [user?.token]);

  const _initializeHotjar = useEffectEvent(() => {
    initializeHotjar(user, isAdminUser);
  });
  useEffect(() => {
    _initializeHotjar();
  }, [_initializeHotjar]);

  useEffect(() => {
    initializeFaireGeneralWebSocketChannels(
      handleInvalidateProductReviewCampaignComponents
    );
  }, [handleInvalidateProductReviewCampaignComponents]);

  useEffect(() => {
    initializeNotificationWebSocketChannels(
      handleRetailerUserNotificationChannelMessage
    );
  }, [handleRetailerUserNotificationChannelMessage]);

  useEffect(() => {
    subscribeAddToCartEvents(history);
  }, [history]);
};

export const PostInteractiveInitializer: React.FC<{ history: History }> = ({
  history,
}) => {
  usePostAppInitialization(history);
  return null;
};
